var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxGrayMd = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 172,
  height: 152,
  fill: "none",
  viewBox: "0 0 172 152",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 72,
  r: 64,
  fill: "var(--utility-gray-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 28,
  r: 6,
  fill: "var(--utility-gray-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 120,
  r: 8,
  fill: "var(--utility-gray-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 44,
  r: 8,
  fill: "var(--utility-gray-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 17,
  r: 5,
  fill: "var(--utility-gray-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_1182_1923)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-200, black)",
  d: "m86 44.65 5.616-2.353-5.615 2.392v66.975l51.747-21.685V22.975l.252-.106-.252-.112v-.112l-.13.055L86.408 0 34 22.325l.248.106L34 89.163l52 22.461z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-100, black)",
  d: "M86 44.65v66.974l-52-22.46.248-66.733zM86 44.69v66.974l51.748-21.685V22.645z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-100, black)",
  d: "m86 44.65 52-21.78L86.408 0 34 22.325z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-200, black)",
  d: "m53.602 13.975 51.802 22.547.47 16.431 14.494-5.98-.438-16.535L66.595 8.44z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b_1182_1923)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-400, black)",
  d: "M58 100c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M81.333 104.667 86 100m0 0 4.667 4.667M86 100v10.5m9.333-4.967a6.417 6.417 0 0 0-4.083-11.366.72.72 0 0 1-.623-.353 8.75 8.75 0 1 0-13.742 10.612"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxGrayMd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BoxGrayMd.dfbbb521c34a8ddc0594a114f04effc8.svg";